import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { margin, padding, width } from '@mui/system';

export const useStyles = makeStyles((theme: Theme) => ({
  cardContainer: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    height: '71.5vh !important',
    minHeight: '71.5vh !important',
    borderRadius: '9px !important',
  },
  networkCardContainermobile: {
    
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'start',
    marginBottom: '16px',
   
  },
  filterBtn: {
    background: `${theme.palette.KenColors.ClientPrimaryGrey} !important`,
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    boxShadow: 'none !important',
    fontSize: '0.8rem !important',
    padding: '6px 100px !important',
    minHeight: '36px !important',
    minWidth: '160px !important',
    borderRadius: '8px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem !important',
      padding: '2px 14px !important',
      borderRadius: '6px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      padding: '6px 15px !important',
      fontSize: '10px !important',
    },
  },
  CancelBtn: {
    background: `${theme.palette.KenColors.ClientPrimaryGrey} !important`,
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    boxShadow: 'none !important',
    fontSize: '0.8rem !important',
    padding: '6px 100px !important',
    minHeight: '36px !important',
    minWidth: '130px !important',
    borderRadius: '8px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem !important',
      padding: '2px 14px !important',
      borderRadius: '6px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      padding: '6px 15px !important',
      fontSize: '10px !important',
    },
  },
  cardContainer1: {
    background: theme.palette.KenColors.kenWhite,
    padding: '18px ',
    boxShadow: 'none !important',
    height: 'calc(100vh - 143px)',
    [theme.breakpoints.down('sm')]: {
      height: '100% !important',
    },
    borderRadius: '9px !important',
  },
  cardContainer2: {
    background: theme.palette.KenColors.kenWhite,
    padding: '18px ',
    boxShadow: 'none !important',
    borderRadius: '9px !important',
    border : 'none',
    top: "20%",
    '@media (min-width: 1440px) and (max-width: 1460px)': {
      top: "22%",
    },
  },
  networkCardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'start',
    // height:"35vh"
  },
  cardHolder: {
    boxShadow: 'none !important',
    width: '100% !important',
    marginTop : '16px',
    [theme.breakpoints.down('md')]: {
      marginTop: '50px',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '0px !important',
    },
  },
  networkCard: {
    borderRadius: '12px !important',
    textAlign: 'start',
    width: '100%',
    height: '260px',
    cursor: 'pointer',
    // padding: '10px 10px 10px 10px',
    backgroundColor: '#F6F8FB',
    [theme.breakpoints.down('sm')]: {
      height: '220px',
    },
  },
  cardImage: {
    borderRadius: '50%',
    marginTop: '30px',
    height: '100px',
    width: '100px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '20px',
      height: '72px',
      width: '72px',
    },
  },
  cardHeader: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '12px !important',
    fontWeight: '500 !important',
    textTransform: 'capitalize',
    marginLeft: '10px !important',
    marginTop: '5px !important',
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px !important',
      marginLeft: '0px !important',
    },
    [theme.breakpoints.up('xxl')]: {
      fontSize: '15px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      fontSize: '20px !important',
    },
  },
  cardActionContainer: {
    display: 'flex',
    alignItems: 'start',
    gap: '0px',
    margin: '8px auto',
  },
  cardActionContainerTypo: {
    color: '#585A64',
    fontSize: '14px !important',
    fontWeight: '400 !important',
    marginLeft: '10px !important',
    marginTop: '3px !important',
    [theme.breakpoints.up('xxl')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px !important',
      marginLeft: '0px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '13px !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      fontSize: '16px !important',
    },
  },
  cardActionContainerImg: {
    height: '18px !important',
    width: '18px !important',
    textAlign: 'center',
  },

  paperCustom: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    textAlign: 'start',
    padding: '24px',
    borderRadius: '8px !important',
    width: '100%',
  },
  eventBanner: {
    height: '151px !important',
    width: '151px !important',
    borderRadius: '50% !important',
    objectFit: 'cover',
    '@media (min-width: 1240px) and (max-width: 1440px)': {
      height: '125px !important',
      width: '125px !important',
    },
  },
  cardDesign: {
    marginLeft: "10px",
    paddingLeft: "10px",
    paddingRight: "10%",
    position: "relative",
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '-2.5px',
      right: 0,
      width: '1px',
      height: 'calc(100% + 5px)',
      background: '#D1D4DB',
      zIndex: 1,
      display: 'block',
      '@media (max-width:600px)': {
        display: 'none',
      },
    },
    '@media (min-width: 1440px) and (max-width: 1540px)': {
      paddingRight: "0px",
      marginLeft: "0px",
    },
  },  
  eventBannerHead: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '24px !important',
    fontWeight: '600 !important',
    position: 'absolute',
    margin: '10px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px !important',
    },
  },
  eventDetailsContainer: {
    height: 'auto',
    overflow: 'auto',
    padding: '0px 6px 0px 0px',
    fontSize: '16px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
    },
  },

  eventDetailsHeadingSubContainer: {
    fontSize: '14px !important',
    // marginTop: '10px !important',
    // marginBottom: '20px !important',
  },
  eventDetailsHeadingTypo: {
    fontSize: '14px !important',
    // marginBottom: '2px !important',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientGrey,
    lineHeight: '20px'
  },
  eventDetailsTypo: {
    color: theme.palette.KenColors.ClientBlack2,
    fontSize: '16px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  eventDetailsTypo2: {
    color: theme.palette.KenColors.ClientBlack,
    fontSize: '14px !important',
    fontWeight: '600 !important',
    lineHeight: '23px',

  },
  networkImg: {
    height: '10px',
    width: '10px',
    [theme.breakpoints.up('xxl')]: {
      height: '58.5px',
      width: '58.5px',
    },
  },
  detailsBox: {
    marginTop: '0px !important',
    // height: '44vh',
    overflowY : 'scroll'
  },
}));
